<script>
  import Fa from "svelte-fa"
  import { faShareFromSquare } from "@fortawesome/free-regular-svg-icons"

  import backend from "~/backend"
  import ImageUpload from "~/components/ImageUpload.svelte"
  import Gallery from "~/components/Gallery.svelte"

  import CookingInfo from "./CookingInfo.svelte"
  import Links from "./Links.svelte"
  import Ingredients from "./Ingredients.svelte"
  import Instructions from "./Instructions.svelte"
  import History from "./History.svelte"

  export let initialData

  let uuid = 0

  let { recipe } = initialData
  let {
    id,
    gallery,
    ingredients,
    instructions,
    cooking_info,
    history,
    public_url
  } = recipe
  let links = recipe.links || []

  const csrfToken =
    document.querySelector('meta[name="csrf-token"]')?.content || ""

  let timer
  const debouncedUpdate = () => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      persistChanges()
    }, 500)
  }

  function persistChanges() {
    const payload = {
      name: recipe.name,
      cooking_info: recipe.cooking_info,
      links: links,
      ingredients: ingredients.map((group) => {
        return {
          name: group.name,
          ingredients: group.ingredients.map(({ name }) => ({ name }))
        }
      }),
      instructions: instructions.map((group) => {
        return {
          name: group.name,
          steps: group.steps.map(({ step }) => ({ step }))
        }
      })
    }
    backend.updateRecipe(recipe.id, { recipe: payload })
  }

  function confirmDelete(event) {
    if (!window.confirm("Are you sure?")) {
      event.preventDefault()
    }
  }

  $: debouncedUpdate(recipe, ingredients, instructions, cooking_info, links)
</script>

<main class="flex flex-col md:flex-row md:space-x-10">
  <div class="flex flex-col md:w-9/12 gap-4 md:gap-2">
    <div class="flex flex-col md:flex-row gap-2 md:items-center">
      <div class="grow">
        <input
          name="name"
          type="text"
          bind:value={recipe.name}
          class="recipe-name"
          placeholder="Recipe name"
        />
      </div>

      <div class="flex flex-row-reverse md:flex-row justify-between gap-2">
        <form
          class="inline-block"
          method="post"
          action={`/recipes/${id}/preparations`}
          data-turbo="false"
        >
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <button type="submit" class="btn btn-primary">Prepare</button>
        </form>
        <button
          class="btn btn-secondary"
          data-controller="clipboard"
          data-clipboard-text-value={public_url}
          data-action="click->clipboard#copy"
        >
          <Fa icon={faShareFromSquare} />
          Share
        </button>
      </div>
    </div>

    <CookingInfo bind:cooking_info />

    <Links bind:links />

    <div
      class="flex flex-col md:flex-row md:mt-4 gap-y-6 md:gap-y-0 md:gap-x-4"
    >
      <div class="w-full md:w-96">
        <Ingredients bind:ingredients />
      </div>

      <div class="w-full">
        <Instructions bind:instructions />
        {#if history.length > 0}
          <History {id} {history} />
        {/if}
      </div>
    </div>
  </div>

  <div class="mt-6 md:mt-0 md:w-3/12">
    <Gallery {gallery} />
    <ImageUpload server={`${id}/upload_image`} />

    <form
      class="text-center"
      method="post"
      action={`/recipes/${id}`}
      on:submit={confirmDelete}
      data-turbo="false"
    >
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <button type="submit" class="btn btn-link-danger"
        ><i class="fa-regular fa-trash-can text-xs" /> Delete</button
      >
    </form>
  </div>
</main>

<style>
  input[type="text"] {
    @apply border hover:cursor-pointer
       border-transparent bg-transparent appearance-none rounded w-full xl:w-140
        px-2 md:-mx-2 text-fg leading-tight;
    @apply cursor-pointer;
    @apply focus:bg-white focus:shadow focus:border focus:outline-none focus:no-underline;
  }

  .recipe-name {
    @apply text-2xl underline-offset-8;
  }
</style>
